// NPM Imports
import React from "react";
import { VariableSizeList as List } from "react-window";

/**
 *  <ReactWindowList /> :: used to render only the visible list
 *  1. have to pass the follwoing porps
 *    - 'listContainerWidth' & 'listContainerHeight' of the list container
 *    - 'listRef'              : current reference of list item (for reseting the cache)
 *    - 'listItemMinHeight'    : min heigth of individual list item
 *    - 'listItemMaxHeight'    : max heigth of individual list item based on height param
 *    - 'listItemHeightConfig' : obj with key & length properties, which will be used to calculate the list item height
 *    - 'getItemSize'          : method which returns the height of itemList
 *    - 'itemsList'            : items list array
 *    - 'getListComponent'     : returns the list items with style and listItem data
 *  2. used the "react-window" for rendering purpose
 *     read more "https://addyosmani.com/blog/react-window/"
 */

const ReactWindowList = props => {
  const {
    itemsList,
    listContainerWidth,
    listContainerHeight,
    listItemMinHeight,
    listItemMaxHeight,
    getListComponent,
    listClassName,
    listContainerClassName,
    listItemHeightConfig,
  } = props;

  // get the height of list item based on list item data
  const getItemSize = index => {
    if (listItemHeightConfig && listItemMaxHeight) {
      if (
        itemsList[index][listItemHeightConfig.key] &&
        itemsList[index][listItemHeightConfig.key].length >=
          listItemHeightConfig.length
      ) {
        return listItemMaxHeight;
      }
    }
    return listItemMinHeight;
  };

  // get the list item component(row)
  const Row = ({ index, style }) => (
    <div className={listClassName} style={style}>
      {getListComponent(style, itemsList[index])}
    </div>
  );

  // Clear the cache
  if (props.listRef && props.listRef.current) {
    props.listRef.current.resetAfterIndex(0);
  }

  return (
    <List
      ref={props.listRef}
      className={listContainerClassName}
      height={listContainerHeight}
      width={listContainerWidth}
      itemCount={itemsList.length}
      itemSize={getItemSize}>
      {Row}
    </List>
  );
};

export default ReactWindowList;



// WEBPACK FOOTER //
// ./src/commonComponents/ReactWindowList/index.js